import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de simulation d'un événement d'audit
 * (`POST /AuditLogs/simulate-audit-event`, guide §6.8 — ⚙️ outillage
 * réservé à flashpay-superadmin). `eventId` optionnel (déduplication).
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createSimulateAuditEventSchema = () =>
  z.object({
    eventId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    topic: z.string().trim().min(1, { message: t("requiredFieldError") }),
    actorKeycloakId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    action: z.string().trim().min(1, { message: t("requiredFieldError") }),
    resourceType: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    resourceId: z.string().trim().min(1, { message: t("requiredFieldError") }),
    sourceService: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    beforeState: z.string().or(z.literal("")).optional(),
    afterState: z.string().or(z.literal("")).optional(),
    ipAddress: z.string().trim().or(z.literal("")).optional(),
  });

export type SimulateAuditEventFormValues = z.infer<
  ReturnType<typeof createSimulateAuditEventSchema>
>;
